import React from "react";
import { InputNumber as AntInputNumber } from 'antd';

const componentClass = 'fieldType__number';

const NumberInput = ({ onChange, ...rest }) => {

  return <AntInputNumber
      className={componentClass}
      onChange={v => onChange(v)}
      {...rest}
  />
}
export default NumberInput;
